import { Box, Modal, Typography } from "@mui/material";
import SetPasswordForm from "../../../forms/set-password/SetPasswordForm";
import { useLangContext } from "../../../context/langContext";
import compInfos from "./set-password.json";
import { useProfileContext } from "../../../context/profileContext";

export default function SetPasswordModalComponent() {
  const { passwordSet, setPasswordSet } = useProfileContext();
  const { dir, lang } = useLangContext();

  const handleClose = () => {
    setPasswordSet(false);
  };

  const infos = compInfos[lang];

  return (
    <Modal open={passwordSet} onClose={handleClose}>
      <Box
        dir={dir}
        sx={{
          display: "grid",
          placeContent: "center",
          placeItems: "center",
          height: "100vh",
          zIndex: "999990",
        }}
      >
        <Box
          sx={{
            width: { xs: "95vw", md: "35vw" },
            backgroundColor: (theme) => theme.palette.gray.bg,
            pt: "5px",
            pb: "30px",
            px: "20px",
            borderRadius: "16px",
          }}
        >
          <Typography
            variant="h6MediumBold"
            width="100%"
            component="p"
            sx={{
              width: "100%",
              py: "24px",
              borderBottomStyle: "dashed",
              borderBottomWidth: "2px",
              borderBottomColor: (theme) => theme.palette.gray[400],
              color: (theme) => theme.palette.dominant.main,
            }}
          >
            {infos.title}
          </Typography>
          <Typography
            py="24px"
            component="p"
            variant="footerMediumBold"
            color={(theme) => theme.palette.dominant[400]}
          >
            {infos.subTitle}
          </Typography>
          <SetPasswordForm />
        </Box>
      </Box>
    </Modal>
  );
}
